import { action, thunk } from 'easy-peasy';
import { utilityThrowError } from '@utils/errors';

import type { TJob, TJobStore } from '@model/Job/Job.type';
import { clientsStore } from '@model/Job/clients/Clients';
import { showcaseStore } from '@model/Job/showcase/Showcase';

export const jobStore: TJobStore = {
  loading: true,
  error: false,
  data: null,
  currentJobId: null,
  progress: null,

  setCurrentJobId: action((state, payload) => {
    state.currentJobId = payload;
  }),

  setJobProgress: action((state, payload) => {
    state.progress = payload;
  }),

  setLoading: action((state, payload) => {
    state.loading = payload;
  }),

  setError: action((state, payload) => {
    state.error = payload;
  }),

  setData: action((state, payload) => {
    state.data = payload;
  }),

  getJob: thunk(async (actions, payload, helpers) => {
    const _actions = helpers.getStoreActions() as any;
    const { jobId } = payload || {};

    actions.setLoading(true);
    actions.setError(false);

    try {
      const res = (await _actions.session.authFetch({
        endpoint: `/v1/employer-view/jobs/${jobId}`,
      })) as TJob;

      _actions.showcaseTable.setShowcaseConfiguration(
        res.showcaseConfiguration,
      );
      actions.setData(res);
      return res;
    } catch (error) {
      actions.setError(true);
      utilityThrowError(
        error,
        'Unable to retrieve job details related to this job ID',
      );

      return;
    } finally {
      actions.setLoading(false);
    }
  }),

  getJobProfilingMeetingDocument: thunk(async (_actions, payload, helpers) => {
    const _storeActions = helpers.getStoreActions();
    const { jobId } = payload;

    try {
      const { filename, blob } = await _storeActions.session.authFetchPdf({
        endpoint: `/v1/employer-view/jobs/${jobId}/downloads/profiling-meeting-document`,
        requestOptions: {
          headers: {
            'Content-Type': 'application/pdf',
          },
        },
      });

      return {
        filename,
        url: URL.createObjectURL(blob),
      };
    } catch (error) {
      utilityThrowError(
        error,
        `Unable to retrieve profiling meeting document related to job with ID: ${jobId}`,
      );
      return null;
    }
  }),

  clients: clientsStore,
  showcase: showcaseStore,
};
